import { PortalWrapper } from 'app/App.styles';
import styled, { from } from 'theme';

export const AuthorizationWrapper = styled(PortalWrapper)`
  .page-header {
    justify-content: center;
    margin-bottom: 2rem;
  }

  .button[type='submit'] {
    margin-top: 1.5rem;
    padding: 0 1.875rem;
  }

  .authorization__content {
    padding: 1rem 0;

    ${from('md')} {
      padding: 4rem 0;
    }

    .form {
      padding: 0 3rem;
    }
  }
`;
